import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.vendor || initialState;

export const selectVendorData = createSelector([selectSlice], state => state);

export const selectVendorGTMCode = createSelector(
  [selectSlice],
  state => state.gtm_code,
);

export const selectVendorFeatures = createSelector(
  [selectSlice],
  state => state.features,
);

export const selectMerchantTaxName = createSelector(
  [selectSlice],
  state => state.merchantTaxName,
);
